<template>
  <div class="part3 part_box" ref="part3">
    <div class="part3_hd fix">
      <div class="f-fl">
        <div class="title_left">
          <i class="detail_ico_40 ship per_nums"></i>选择入住人数
        </div>
      </div>
      <div class="f-fl">
        <div class="title_tips" @click="showCruisePriceInfo">
          价格说明<img
            class="det_icon"
            src="https://resource.rcclchina.com.cn/tui2/info/webhao.png"
        />
        </div>
      </div>
      <div class="f-fr nrpTips" v-if="isShowNrp">
        <img src="https://resource.rcclchina.com.cn/tui2/nrp.jpg" />
      </div>
      <div class="f-fr" v-if="isPPP">
        <img src="https://resource.rcclchina.com.cn/partner/ppp.jpg" />
      </div>
    </div>
    <div class="part3_bd">
      <div class="tab_hd" style="margin-bottom: 10px">
        <div class="row new-gutter " :class="[showRow == false ?'show-connect-room':'']">
          <div class="col-md-3 col-lg-3 col-xs-3 col-sm-3">
            <div
                class="list_box roomInfo"
                :class="{ active: currentGuestNumber == 1}"
                @click="onGuestNumberChange(1)"
            >
              <img
                  src="https://resource.rcclchina.com.cn/cruiseDetail/sing-room.jpg"
                  alt=""
              />
              <i class="pop_bj opacity"></i>
              <i class="pop_border">单人房</i>
              <div class="pop_tips" :class="{c_room_outOfStock:getCruiseOutOfStock()}" v-if="isShowOutOfStockText">
                <span v-if="cruiseDetail.outOfStockEnable">(缺货登记)</span>
                <span v-else>(售罄)</span>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-lg-3 col-xs-3 col-sm-3">
            <div
                class="list_box roomInfo"
                :class="{ active: currentGuestNumber == 2}"
                @click="onGuestNumberChange(2)"
            >
              <img
                  src="https://resource.rcclchina.com.cn/tui2/cruise/guestNumber2.jpg"
                  alt=""
              />
              <i class="pop_bj"></i>
              <i class="pop_border">双人房</i>
              <div class="pop_tips" :class="{c_room_outOfStock:getCruiseOutOfStock()}"  v-if="isShowOutOfStockText">
                <span v-if="cruiseDetail.outOfStockEnable">(缺货登记)</span>
                <span v-else>(售罄)</span>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-lg-3 col-xs-3 col-sm-3">
            <div
                class="list_box roomInfo"
                :class="{ active: currentGuestNumber == 3}"
                @click="onGuestNumberChange(3)"
            >
              <img
                  src="https://resource.rcclchina.com.cn/tui2/cruise/guestNumber3.jpg"
                  alt=""
              />
              <i class="pop_bj"></i>
              <i
                  class="pop_border"
                  :class="{ QIAOHU_pop_border: qiaohu3Stock > 0 }"
              >三人房</i
              >
              <i class="QIAOHU_center" v-if="qiaohu3Stock > 0"></i>
              <i class="QIAOHU_guestRoom" v-if="qiaohu3Stock > 0">限量巧虎房</i>
              <div class="pop_tips" :class="{c_room_outOfStock:getCruiseOutOfStock()}"  v-if="isShowOutOfStockText">
                <span v-if="cruiseDetail.outOfStockEnable">(缺货登记)</span>
                <span v-else>(售罄)</span>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-lg-3 col-xs-3 col-sm-3">
            <div
                class="list_box roomInfo"
                :class="{ active: currentGuestNumber == 4}"
                @click="onGuestNumberChange(4)"
            >
              <img
                  src="https://resource.rcclchina.com.cn/tui2/cruise/guestNumber4.jpg"
                  alt=""
              />
              <i class="pop_bj opacity"></i>
              <i
                  class="pop_border"
                  :class="{ QIAOHU_pop_border: qiaohu3Stock > 0 }"
              >四人房</i
              >
              <i class="QIAOHU_center" v-if="qiaohu3Stock > 0"></i>
              <i class="QIAOHU_guestRoom" v-if="qiaohu3Stock > 0">限量巧虎房</i>
              <div class="pop_tips" :class="{c_room_outOfStock:getCruiseOutOfStock()}" v-if="isShowOutOfStockText">
                <span v-if="cruiseDetail.outOfStockEnable">(缺货登记)</span>
                <span v-else>(售罄)</span>
              </div>
            </div>
          </div>
          <div
              class="col-md-3 col-lg-3 col-xs-3 col-sm-3 col-last col-connect-room"
              @mouseenter="isShowConnect = true"
              @mouseleave="isShowConnect = false"
              v-if="showRow == false"
          >
            <div
                class="list_box roomInfo list_more"
                :class="{ active: isConnectRoomMode}"
            >
              <img
                  style="width: 100%"
                  src="https://resource.rcclchina.com.cn/connectRoom/connect-room-tab-normal.png"
                  alt=""
              />
              <i class="pop_bj opacity"></i>
              <i
                  class="pop_border pop_dis"
                  v-if="currentConnectGuestCount == '2,2'"
              >
<!--                :class="{c_room_outOfStock:!getCruiseOutOfStock() }"-->
                <span class="pop_pers" style="width: auto" >多人连通房
                </span>
                <span class="pop_even">双人房&nbsp;+&nbsp;双人房</span>
                <img
                    src="https://resource.rcclchina.com.cn/cruiseDetail/pc/arrow_down.png"
                    style="
                    width: 21px;
                    height: 11px;
                    position: absolute;
                    left: 50%;
                    margin-left: -10px;
                    bottom: 8px;
                  "
                    alt=""
                />
              </i>
              <i
                  class="pop_border pop_dis"
                  v-else-if="currentConnectGuestCount == '2,3'"
              >
                <span class="pop_pers" style="width: auto">多人连通房
                </span>
                <span class="pop_even">双人房&nbsp;+&nbsp;三人房</span>
                <img
                    src="https://resource.rcclchina.com.cn/cruiseDetail/pc/arrow_down.png"
                    style="
                    width: 21px;
                    height: 11px;
                    position: absolute;
                    left: 50%;
                    margin-left: -10px;
                    bottom: 8px;
                  "
                    alt=""
                />
              </i>
              <i class="pop_border pop_show" v-else>
                多人连通房
                <img
                    class="pop_new"
                    src="https://resource.rcclchina.com.cn/cruiseDetail/pc/new.png"
                    alt=""
                />
              </i>
            </div>

            <!--多人房hover效果-->
            <div class="mask-box" v-show="isShowConnect">
              <div class="mask-pic">
                <img
                    src="https://resource.rcclchina.com.cn/connectRoom/connect-room-tab-hover.png"
                />
                <div class="choose-title">请选择房型组合</div>
              </div>
              <div
                  class="roomtype_even roomtype"
                  :class="{ active: currentConnectGuestCount == '2,2'}"
                  @click="onConnectGuestSelected('2,2')"
              >
                双人房&nbsp;+&nbsp;双人房(组合)
              </div>
              <div
                  class="roomtype_odd roomtype"
                  :class="{ active: currentConnectGuestCount == '2,3'}"
                  @click="onConnectGuestSelected('2,3')"
              >
                双人房&nbsp;+&nbsp;三人房(组合)
              </div>
              <img
                  @click="showConnectRoomPopup"
                  class="type_img"
                  src="https://resource.rcclchina.com.cn/cruiseDetail/pc/connect_what.png"
                  alt=""
              />
              <img
                  class="pop_new h_pop"
                  src="https://resource.rcclchina.com.cn/cruiseDetail/pc/new.png"
                  alt=""
              />
            </div>
          </div>
        </div>
      </div>

      <!--新增开始-->
      <div class="part3_hd fix title_box">
        <div class="f-fl title_box">
          <div class="title_left">
            <i class="detail_ico_40 ship"></i>选择舱房类型
          </div>
          
        </div>
        <div class="helper-box" @click="isShowHelperopup = true" v-if="showRow == false">
            <img class="helper-box-home" :src="currImgUrl+'searchHome.png'" alt="">
            <div>选房助手</div>
            <img class="helper-box-arrow" :src="currImgUrl+'yaIconLeft.png'" alt="">
        </div>
      </div>
      <!--新增结束-->

      <div class="tab_hd_child">
        <!--
                ** cur为选中状态类名
                ** first_label 70%用户首选
                ** over_label 已售罄
                --->
        <ul class="row no-gutter selectRoom__tab">
          <li
              class="col-md-3 col-lg-3 col-xs-3 col-sm-3 tab_elem"
              :class="{
              over_label: getStateroomLowestPrice('INTERIOR') == 0 && isConnectRoomMode,
              cur: currentStateroomType == 'INTERIOR',
            }"
              @click="onStateroomTypeChanged('INTERIOR')"
          >
            <div class="list_box">
              <div class="room_type">内舱房</div>
              <div
                  v-if="getStateroomLowestPrice('INTERIOR') > 0"
                  class="roo_price"
              >
                ￥{{
                  getStateroomLowestPrice("INTERIOR").toFixed(0)
                }}/人起(含税)
              </div>
            </div>
            <!-- row 不显示 -->
            <div class="outOfStockTips" v-if="!isConnectRoomMode && getStateroomLowestPrice('INTERIOR') == 0 && isShowOutOfStockText && showRow == false">
              <span v-if="cruiseDetail.outOfStockEnable">缺货登记</span>
              <span v-else>售罄</span>
            </div>
          </li>
          <li
              class="col-md-3 col-lg-3 col-xs-3 col-sm-3 tab_elem"
              :class="{
              over_label: getStateroomLowestPrice('OUTSIDE') == 0 && isConnectRoomMode,
              cur: currentStateroomType == 'OUTSIDE',
            }"
              @click="onStateroomTypeChanged('OUTSIDE')"
          >
            <div class="list_box">
              <div class="room_type">海景房</div>
              <div
                  v-if="getStateroomLowestPrice('OUTSIDE') > 0"
                  class="roo_price"
              >
                ￥{{ getStateroomLowestPrice("OUTSIDE").toFixed(0) }}/人起(含税)
              </div>
            </div>
            <div class="outOfStockTips" v-if="!isConnectRoomMode && getStateroomLowestPrice('OUTSIDE') == 0 && isShowOutOfStockText && showRow == false">
              <span v-if="cruiseDetail.outOfStockEnable">缺货登记</span>
              <span v-else>售罄</span>
            </div>
          </li>
          <li
              class="col-md-3 col-lg-3 col-xs-3 col-sm-3 tab_elem first_label"
              :class="{
              over_label: getStateroomLowestPrice('BALCONY') == 0 && isConnectRoomMode,
              cur: currentStateroomType == 'BALCONY',
            }"
              @click="onStateroomTypeChanged('BALCONY')"
          >
            <div
                class="QIAOHU_CASS_ROOM_CSS"
                style="position: absolute; left: 21px; bottom: 23px"
                v-show="hasQiaohu"
            >
              <img
                  src="https://resource.rcclchina.com.cn/QIAOHU/PC/categoryQIAOHU.png"
              />
            </div>
            <div class="list_box">
              <div class="room_type">阳台房</div>
              <div
                  v-if="getStateroomLowestPrice('BALCONY') > 0"
                  class="roo_price"
              >
                ￥{{ getStateroomLowestPrice("BALCONY").toFixed(0) }}/人起(含税)
              </div>
            </div>
            <div class="outOfStockTips" v-if="!isConnectRoomMode && getStateroomLowestPrice('BALCONY') == 0 && isShowOutOfStockText && showRow == false">
              <span v-if="cruiseDetail.outOfStockEnable">缺货登记</span>
              <span v-else>售罄</span>
            </div>
          </li>
          <li
              class="col-md-3 col-lg-3 col-xs-3 col-sm-3 tab_elem"
              :class="{
              over_label: getStateroomLowestPrice('DELUXE') == 0 && isConnectRoomMode,
              suite_label: getStateroomLowestPrice('DELUXE') > 0 && showRow == false,
              cur: currentStateroomType == 'DELUXE',
            }"
              @click="onStateroomTypeChanged('DELUXE')"
          >
            <div class="list_box">
              <div class="room_type">套房</div>
              <div
                  v-if="getStateroomLowestPrice('DELUXE') > 0"
                  class="roo_price"
              >
                ￥{{ getStateroomLowestPrice("DELUXE").toFixed(0) }}/人起(含税)
              </div>
            </div>
            <div class="outOfStockTips" v-if="!isConnectRoomMode && getStateroomLowestPrice('DELUXE') == 0 && isShowOutOfStockText && showRow == false">
              <span v-if="cruiseDetail.outOfStockEnable">缺货登记</span>
              <span v-else>售罄</span>
            </div>
          </li>
        </ul>
      </div>


      <SuiteTabs v-if="currentStateroomType === 'DELUXE' && showRow == false"
                 @switch="suiteTagsSwitch"
                 :showStateroomSuitePopup="showStateroomSuitePopup"
                 :suiteImage="cruiseDetail.suiteImagePC"
                 :shipCode="cruiseDetail.shipCode"/>

      <div class="part3_tips"></div>
      <div class="tab_bd">
        <!--房型为空提示（已隐藏）--->
        <div
            class="room_type_null"
            v-show="getStateroomLowestPrice(currentStateroomType) == 0"
        >
          当前没有可供{{
            currentGuestNumber || setConnectGuestCount()
          }}人入住的舱房，请您切换其他房型或稍后刷新重试！
        </div>
        <ul
            class="stateroom_list"
            v-if="
            !isConnectRoomMode &&
            getStateroomLowestPrice(currentStateroomType) > 0
          "
        >
          <StateroomItem
              v-for="(stateroom, i) in allStaterooms"
              :key="getStateroomKey(stateroom, i)"
              v-show="stateroom.stateroomType == currentStateroomType && isShowItem(stateroom)"
              :suiteTagSelected="suiteTagSelected"
              :shipCode="shipCode"
              :sailDate="sailDate"
              :packageCode="cruiseDetail.packageCode"
              :nrpDefaultSelectedType="cruiseDetail.nrpDefaultSelectedType"
              :stateroom="stateroom"
              :index="i"
              :guestNumber="currentGuestNumber"
              :qiaohuGroup="qiaohuGroup"
              :stateroomType="stateroom.stateroomType"
              :shoppingCarts="shoppingCarts"
              :onShoppingCartAdd="onShoppingCartAdd"
              :onShoppingCartDelete="onShoppingCartDelete"
              :showStateroomDetail="showStateroomDetailPopup"
              :showStateroomSuitePopup="showStateroomSuitePopup"
              :showQiaohuPopup="showQiaohuPopup"
              :showStarrySkyPopup="showStarrySkyPopup"
              :showCustomThemePopup="showCustomThemePopup"
              :isFortyEightHoursNrpCruise="cruiseDetail.isFortyEightHoursNrpCruise"
              :specialBookingInfo="specialBookingInfo"
              :showRow="showRow"
          />
        </ul>

        <ul
            class="stateroom_list"
            v-if="
            isConnectRoomMode &&
            getStateroomLowestPrice(currentStateroomType) > 0
          "
        >
          <ConnectStateroomItem
              v-for="(stateroom, i) in getConnectStateroom(currentStateroomType)"
              :key="getConnectStateroomKey(stateroom, i)"
              v-show="stateroom.stateroomType == currentStateroomType && isShowItemCon(stateroom)"
              :suiteTagSelected="suiteTagSelected"
              :shipCode="shipCode"
              :sailDate="sailDate"
              :index="i"
              :packageCode="cruiseDetail.packageCode"
              :nrpDefaultSelectedType="cruiseDetail.nrpDefaultSelectedType"
              :connectStateroom="stateroom"
              :stateroomType="currentStateroomType"
              :shoppingCarts="shoppingCarts"
              :onConnectShoppingCartAdd="onConnectShoppingCartAdd"
              :onShoppingCartDelete="onShoppingCartDelete"
              :showStateroomDetail="showStateroomDetailPopup"
              :showStateroomSuitePopup="showStateroomSuitePopup"
              :showConnectRoomPopup="showConnectRoomPopup"
              :isFortyEightHoursNrpCruise="cruiseDetail.isFortyEightHoursNrpCruise"
              :specialBookingInfo="specialBookingInfo"
              :showRow="showRow"
          />
        </ul>

        <!-- 收起房型 按钮 -->
         <template v-if="!isConnectRoomMode">
          <div class="folded-box" v-if="isShowFolded == true" @click="clickItem = !clickItem">
            <div class="folded-box-text"> {{clickItem == true ? '收起全部房型':'展开查看全部房型'}}</div>
            <template>
              <img :class="[clickItem == true?'':'folded-box-text-img']" :src="currImgUrl+'xialajiantou.png'" alt="">
            </template>
          </div>
        </template>
        <template v-else>
          <div class="folded-box" v-if="isShowFoldedCon == true" @click="clickItemCon = !clickItemCon">
            <div class="folded-box-text"> {{clickItemCon == true ? '收起全部房型':'展开查看全部房型'}}</div>
            <template>
              <img :class="[clickItemCon == true?'':'folded-box-text-img']" :src="currImgUrl+'xialajiantou.png'" alt="">
            </template>
          </div>
        </template>

        <!--房型合计--->
        <div class="total_box fix add_guestInfo" ref="stateroomTotalBox">
          <div class="f-fl cruise-shoppingcart-tips">
            同一航线一次预订最多可选<em>3</em>间舱房
          </div>
          <div class="f-fr">
            <div class="price_deposit_info">
              <div class="total_price" :class="{'is_deposit': cruiseDetail.isDownPayCruise}">
                <span class="room_num all_room_num cursor-pointer" @click="showShoppingCart()">{{ shoppingCarts.length }}间</span>
                <em class="price_title">总价：</em>
                <em class="unit">￥</em>
                <em class="price_num all_price_num">{{totalAmount.toFixed(0)}}</em>
<!--                <em class="price_details">明细</em>-->
              </div>
              <!-- row 不显示 -->
              <div v-if="cruiseDetail.isDownPayCruise && showRow == false" class="total_deposit">
                <img :src="`${imgUrl}/cruiseSearch/icons/icon-deposit.svg`"/>
                <span v-if="isDeluxeStateroom">实际订金金额以结算为准</span>
                <span v-else>支持订金预付：¥{{totalDeposit.toFixed(0)}}</span>
              </div>
            </div>
            <SubmitShoppingCartButton
                class="next_btn"
                :shoppingCarts="shoppingCarts"
            />
          </div>
        </div>
        <div class="total_box fix floating-button" v-show="isTotalBoxFixed">
          <div class="f-fl cruise-shoppingcart-tips">
            同一航线一次预订最多可选<em>3</em>间舱房
          </div>
          <div class="f-fr">
            <!--            <span-->
            <!--              class="room_num all_room_num cursor-pointer"-->
            <!--              @click="showShoppingCart()"-->
            <!--              >{{ shoppingCarts.length }}间</span-->
            <!--            >-->
            <!--            <span class="total_price"-->
            <!--              ><em class="price_title">总价：</em><em class="unit">￥</em>-->
            <!--              <em class="price_num all_price_num">{{-->
            <!--                totalAmount.toFixed(0)-->
            <!--              }}</em></span-->
            <!--            >-->
            <!--            <span class="total_deposit">-->
            <!--              支持订金预付{{totalDeposit.toFixed(0)}}-->
            <!--            </span>-->
            <div class="price_deposit_info">
              <div class="total_price" :class="{'is_deposit': cruiseDetail.isDownPayCruise}">
                <span class="room_num all_room_num cursor-pointer" @click="showShoppingCart()">{{ shoppingCarts.length }}间</span>
                <em class="price_title">总价：</em>
                <em class="unit">￥</em>
                <em class="price_num all_price_num">{{totalAmount.toFixed(0)}}</em>
<!--                <em class="price_details">明细</em>-->
              </div>
              <div v-if="cruiseDetail.isDownPayCruise" class="total_deposit">
                <img :src="`${imgUrl}/cruiseSearch/icons/icon-deposit.svg`"/>
                <span v-if="isDeluxeStateroom">实际订金金额以结算为准</span>
                <span v-else>支持订金预付：¥{{totalDeposit.toFixed(0)}}元起</span>
              </div>
            </div>
            <SubmitShoppingCartButton
                class="next_btn"
                :shoppingCarts="shoppingCarts"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="outOfStockPopup" v-if="isShowOutOfStockPopup">
      <div class="outOfStockCon">
        <div class="outOfStockHeader">
          缺货登记
          <img @click="closeOutOfStockPopup()" src="https://resource.rcclchina.com.cn/invoice/popupClose-icon.png" alt="">
        </div>
        <div class="outOfStock-title">
          该舱房类型暂时售罄，推荐您预订同款或临近航线：
        </div>
        <div class="recommendedRoute-list">
          <OutOfStockCruiseList :cruiseCategories="outOfStockCruiseList"
                                :stateroomType="currentStateroomType"
                                :guestNumberCount="guestNumberCount"></OutOfStockCruiseList>

        </div>
        <div class="outOfStock-title">仍需缺货登记</div>
        <div class="outOfStock-roomName">
          您登记的缺货房型为：
          <div class="roomName">
            {{roomName}}
          </div>
        </div>
        <div class="outOfStock-selectRoom" v-if="!hideSelectRoom">
          <div class="outOfStock-roomName">请选择您的偏好：</div>
          <div class="selectRoom-main">
            <div class="selectRoom-item"
                 v-for="(i,idx) in outOfStockRoom"
                 :key="idx" @click="changeOutOfStockRoom(i,idx)">
              <img v-if="!i.isActive" src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-def-1.jpg" alt="">
              <img v-else src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-checkBox-checked-1.jpg" alt="">
              {{i.typeName}}
            </div>
          </div>
        </div>
        <div v-if="!isHaveRegistered" class="confirmBtn" @click="submitOutOfStock">确认登记</div>
        <div v-else class="haveRegistered">已登记</div>
        <div class="outOfStock-tips">有舱后将以短信及微信消息的形式通知您</div>
        <div v-if="isShowNullRoomTips" class="noSelectRoomTips" >
          <div class="tips-text">
            请选择您偏好的房型后再提交
          </div>
        </div>
      </div>
    </div>
    <StateroomDetail
        v-on:onModalClose="closeStateroomDetailPopup"
        :isShow="isShowStateroomDetailPopup"
        :stateroomDetail="selectStateroom"
        :isFortyEightHoursNrpCruise="cruiseDetail.isFortyEightHoursNrpCruise"
        :showQiaohuPopup="showQiaohuPopup"
        :showStarrySkyPopup="showStarrySkyPopup"
        :showCustomThemePopup="showCustomThemePopup"
        :isShowPrice="true"
        :showRow="showRow"
    />

    <StateroomDetailSuite
        v-on:onModalClose="closeStateroomDetailSuitePopup"
        :isShow="isShowStateroomDetailSuitePopup"
        :stateroomDetail="selectStateroom"
        :isFortyEightHoursNrpCruise="cruiseDetail.isFortyEightHoursNrpCruise"
        :showQiaohuPopup="showQiaohuPopup"
        :showStarrySkyPopup="showStarrySkyPopup"
        :showCustomThemePopup="showCustomThemePopup"
        :isShowPrice="true"
        :showStateroomSuitePopup="showStateroomSuitePopup"
        :showRow="showRow"
    />

    

    <!-- 选房助手  row 不显示-->
     <helperRomePopover
        :shipCodeHelper="cruiseDetail.shipCode"
        :suiteImage="suiteImage"
        v-on:onModalClose="closeHelperRomePopover"
        :isShow="isShowHelperopup && showRow == false"
        :showStateroomSuitePopup="showStateroomSuitePopup"
    />

    <SuiteStateroomPopup
        :suiteImage="suiteImage"
        v-on:onModalClose="closeStateroomSuitePopup"
        :isShow="isShowSuitePopup"
    />

    <CruisePricePopup
        :isShow="isShowCruisePriceInfoPopup"
        v-on:onModalClose="closeCruisePriceInfo"
    />

    <QiaohuPopup
        :shipCode="shipCode"
        :sailDate="sailDate"
        v-on:onModalClose="closeQiaohuPopup"
        :isShow="isShowQiaohuPopup"
    />

    <StarrySkyPopup
        :shipCode="shipCode"
        :sailDate="sailDate"
        v-on:onModalClose="closeStarrySkyPopup"
        :isShow="isShowStarrySkyPopup"
    />
    <CustomThemePopup
      :isShow="isShowCustomThemePopup"
      :themeInfo="customThemeInfo"
      v-on:onModalClose="closeCustomThemePopup"
    />

    <ConnectRoomPopup
        v-on:onModalClose="closeConnectRoomPopup"
        :isShow="isShowConnectRoomPopup"
    />
  </div>
</template>

<script>
import api from "@/api";
import _ from "lodash";
import bookingHelper from "@/utilities/bookingHelper";
import { gioTracking } from "@/utilities/tools";
import StarrySkyPopup from "@/components/Cruise/CruiseDetail/StarrySkyPopup.vue";
import OutOfStockCruiseList from "@/components/Cruise/CruiseDetail/OutOfStockCruiseList.vue";
import CustomThemePopup from "@/components/Cruise/CruiseDetail/CustomThemePopup.vue";
const StateroomItem = () =>
    import("@/components/Cruise/CruiseDetail/StateroomItem.vue");
const ConnectStateroomItem = () =>
    import("@/components/Cruise/CruiseDetail/ConnectStateroomItem.vue");
const StateroomDetail = () =>
    import("@/components/Booking/StateroomDetail.vue");
const StateroomDetailSuite = () =>
    import("@/components/Booking/StateroomDetailSuite.vue");
const SuiteStateroomPopup = () =>
    import("@/components/Cruise/CruiseDetail/SuiteStateroomPopup.vue");
const helperRomePopover = () =>
    import("@/components/Cruise/CruiseDetail/helperRomePopover.vue");
const QiaohuPopup = () =>
    import("@/components/Cruise/CruiseDetail/QiaohuPopup.vue");
const ConnectRoomPopup = () =>
    import("@/components/Cruise/CruiseDetail/ConnectRoomPopup.vue");
const CruisePricePopup = () =>
    import("@/components/Cruise/CruiseDetail/CruisePricePopup.vue");
const SubmitShoppingCartButton = () =>
    import("@/components/Cruise/CruiseDetail/SubmitShoppingCartButton.vue");
const SuiteTabs = () =>
    import("@/components/Suite/SuiteTabs.vue");
export default {
  name: "CruiseDetailStateroom",
  components: {
    CustomThemePopup,
    OutOfStockCruiseList,
    StarrySkyPopup,
    StateroomItem,
    helperRomePopover,
    ConnectStateroomItem,
    StateroomDetail,
    StateroomDetailSuite,
    SuiteStateroomPopup,
    QiaohuPopup,
    ConnectRoomPopup,
    CruisePricePopup,
    SubmitShoppingCartButton,
    SuiteTabs
  },
  props: {
    cruiseDetail: {
      type: Object,
    },
    showLoginPopup: {
      type: Function,
    },
    showRow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tenSecondDoFn:'',
      timerScroll:null,
      isShowHelperopup:false,
      imgUrl: process.env.VUE_APP_IMG_URL,
      currentGuestNumber: 2,
      currentStateroomType: "INTERIOR",
      stateroomCategories: [],
      currentConnectGuestCount: "",
      isShowConnect: false,
      shoppingCarts: [],
      suiteImage: "",
      selectStateroom: {
        stateroomImages: [],
        stateroomName: "",
        stateroomCategory: "",
        stateroomPriceType: "",
        stateroomPrice: 0,
        stateroomCapacity: "",
        stateroomArea: "",
        stateroomBalcony: "",
        stateroomFloor: "",
        isQiaohu: false,
        isStarrySky: false,
        stateroomDescription: "",
        stateroomNrpTitle: "",
        stateroomNrpText: "",
        suiteMobileImageUrl: "",
        isNrp: false,
      },
      isShowSuitePopup: false,
      isShowQiaohuPopup: false,
      isShowStarrySkyPopup: false,
      isShowConnectRoomPopup: false,
      isShowCancelPolicyPopup: false,
      isShowStateroomDetailPopup: false,
      isShowStateroomDetailSuitePopup: false,
      isShowCruisePriceInfoPopup: false,
      isTotalBoxFixed: false,
      depositPrice: 1000,
      suiteTagSelected: -1,
      userInfo: null,
      isShowOutOfStockPopup:false, // 缺货弹窗
      outOfStockRoom: null,  // 缺货信息
      outOfStockCruiseList: null, // 缺货舱房信息
      outOfStockIds:[],
      isShowNullRoomTips:false,
      isHaveRegistered:false,
      roomName:'',
      hideSelectRoom:false, // 选择房间显示
      guestNumberCount:0,
      isShowOutOfStockText:false,
      cabinRoomType:'',
      cruiseRoomData:[],
      isLoading:true,
      clickItem:false,
      currImgUrl: process.env.VUE_APP_IMG_URL + '/wechatMiniProgram/routesDetail/housingSelection/',
      clickItemCon:false,
      isShowCustomThemePopup: false,
      customThemeInfo: null
    };
  },
  async beforeMount() {
    const {data} = await api.user.getUserInfo();
    if (data) {
      this.userInfo = data;
      this.$store.commit("SET_USER_INFO", {userInfo: data});
    }
    this.initData();
    
    const self = this;

    window.addEventListener("scroll", () => {
      self.pageScrollHandler(window.scrollY);
    });

    // row 不显示选房助手
    if(this.showRow == false){
      this.startTimer();
      // 清空10s显示 选房助手
      if(this.tenSecondDoFn){
        this.tenSecondDoFn = ''
      }
    }
    
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.pageScrollHandler);
  },
  methods: {
    // 判断十秒内没有操作
    openHelpFn(){
      // 每次进入页面 只弹出一次
      if(this.tenSecondDoFn) return clearTimeout(this.timerScroll);
      // 有弹框的情况下不执行
      if(!this.isShowConnectRoomPopup && !this.isShowStarrySkyPopup
        && !this.isShowQiaohuPopup && !this.isShowCruisePriceInfoPopup
        && !this.isShowSuitePopup && !this.isShowHelperopup
        && !this.isShowStateroomDetailSuitePopup
        && !this.isShowStateroomDetailPopup
      ){
         this.tenSecondDoFn = 'finish'
        // 显示弹框
        this.isShowHelperopup = true
        clearTimeout(this.timerScroll);
      }else{
        this.startTimer()
      }
    },
    startTimer() {
      
      // 每次进入页面 只弹出一次
      if(this.tenSecondDoFn) return clearTimeout(this.timerScroll);

      if(this.timerScroll){
        clearTimeout(this.timerScroll); // 清除之前的定时器，以防万一
        this.tenSecondDoFun()
      }else{
        this.tenSecondDoFun()
      }
      
    },
    tenSecondDoFun() { 
      this.timerScroll = setTimeout(() => {
            console.log('30秒内没有操作');
            this.openHelpFn();
            // 这里可以执行没有操作的逻辑
        }, 30000); // 30秒后触发
    },
    initData() {
      this.isLoading = true;
      if (
          this.cruiseDetail.price &&
          this.cruiseDetail.price.nrpGuestNumber > 0
      ) {
        this.currentGuestNumber = this.cruiseDetail.price.nrpGuestNumber;
      } else if (
          this.cruiseDetail.price &&
          this.cruiseDetail.price.guestNumber > 0
      ) {
        this.currentGuestNumber = this.cruiseDetail.price.guestNumber;
      }
      this.currentConnectGuestCount = "";
      this.getStateroomCategory();
      this.getShoppingCart();
    },
    // 调用获取舱房接口
    async getStateroomCategory() {
      let guestNumbers = [];
      for (let i = 0; i < this.currentGuestNumber; i++) {
        guestNumbers.push(30);
      }
      let requestData = {
        userName: this.$store.state.user.userToken,
        viewModel: {
          guestAges: guestNumbers,
          shipCode: this.shipCode,
          sailDate: this.sailDate,
          packageId: this.cruiseDetail.packageCode,
          agencyId: this.agencyId,
          currency: "CNY",
          connectGuestCount: this.currentConnectGuestCount,
          isPartnerCode: this.isPPP,
        },
      };
      if (this.qiaohuGroup.groupId && this.qiaohuGroup.groupId.length > 0) {
        requestData.viewModel.isGroup = true;
        requestData.viewModel.groupId = this.qiaohuGroup.groupId;
        requestData.viewModel.groupType = this.qiaohuGroup.groupType;
      }
      try {
        this.$loading.show();
        this.isLoading = true;
        const { success, data, errMsg } = await api.cruise.getStateroomCategory(
            requestData
        );
        if (!success) {
          console.error(errMsg);
          this.stateroomCategories = [];
        } else {
          let staterooms = data || [];
          //从接口中重置 currentGuestNumber currentConnectGuestCount值
          if (staterooms?.length > 0) {
               const categoriesItem = staterooms[0]
            // 连通房
            if (categoriesItem.connectGuestCount?.length > 0) {
              this.currentConnectGuestCount=categoriesItem.connectGuestCount
              this.currentGuestNumber = 0    
            } else {
              // 普通房间
              this.currentGuestNumber = categoriesItem.guestAges?.length
              this.currentConnectGuestCount = "";
            }
          }   
          staterooms.forEach((stateroomType) => {
            if (stateroomType.stateroomCategoriesItems) {
              stateroomType.stateroomCategoriesItems.forEach((stateroom) => {
                stateroom.stateroomType = stateroomType.stateroomType;
              });
            }
          });
          this.stateroomCategories = staterooms;
          this.getStateroomSuccessHandler();
          this.isShowOutOfStockText = true;
        }
        this.$loading.hide();
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        this.$loading.hide();
        this.isLoading = false;
        this.stateroomCategories = [];
      }
    },
    // 获取舱房成功后，查找可用的舱房类型
    getStateroomSuccessHandler() {
      if (!this.stateroomCategories || this.stateroomCategories.length == 0) {
        this.currentStateroomType = "";
        return;
      }
      if (this.isConnectRoomMode) {
        const staterooms = _.orderBy(this.stateroomCategories, "lowestPrice");
        this.currentStateroomType = staterooms[0].stateroomType;
      } else {
        const staterooms = this.stateroomCategories.filter(
            (r) =>
                r.stateroomCategoriesItems && r.stateroomCategoriesItems.length > 0
        );
        let stateroomType = "";
        let lowestPrice = 999999999;
        staterooms.forEach((stateroom) => {
          stateroom.stateroomCategoriesItems.forEach((stateroomCategory) => {
            if (stateroomCategory.netAmount < lowestPrice) {
              lowestPrice = stateroomCategory.netAmount;
              stateroomType = stateroom.stateroomType;
            }
          });
        });
        this.currentStateroomType = stateroomType;
      }
    },
    onGuestNumberChange(number) {
      if(this.isLoading) return;
      this.currentGuestNumber = number;
      if (this.currentConnectGuestCount.length > 0) {
        this.currentConnectGuestCount = "";
      }
      this.getStateroomCategory();
      gioTracking('track', 'evt_GuestCount', {
        'GuestNumber': number,
        'shipCode': this.shipCode,
        'sailDate': this.sailDate
      })

      // 收起折叠
      this.clickItem = false;
      this.clickItemCon = false;
    },
    getConnectStateroom(stateroomType) {
      let connectStateroomItems = [];
      if (!this.stateroomCategories || this.stateroomCategories.length == 0) {
        return connectStateroomItems;
      }
      this.stateroomCategories.forEach((connectRooms) => {
        if (
            connectRooms.stateroomType == stateroomType &&
            connectRooms.connectStateroomFirsts &&
            connectRooms.connectStateroomFirsts.length > 0 &&
            connectRooms.connectStateroomSeconds &&
            connectRooms.connectStateroomSeconds.length > 0
        ) {
          const first = this.getConnectRoomPrice(
              connectRooms.connectStateroomFirsts
          );
          const second = this.getConnectRoomPrice(
              connectRooms.connectStateroomSeconds
          );
          const connectId = connectRooms.connectId;
          connectStateroomItems.push({
            connectStateroomFirsts: first,
            connectStateroomSeconds: second,
            connectId,
            isFolded:first.isFolded == true || second.isFolded == true ? true : false,
            stateroomType: connectRooms.stateroomType,
          });
        }
      });
      // console.log(connectStateroomItems,'connectStateroomItemsconnectStateroomItems');
      return connectStateroomItems;
    },
    getConnectRoomPrice(connectStaterooms) {
      let connectStateroomFirst = connectStaterooms[0];
      let stateroom = {
          ...connectStateroomFirst,  // 创建新对象，不修改原对象
          price: [
            {
              originalAmount: connectStateroomFirst.originalAmount,
              portCharges: connectStateroomFirst.portCharges,
              netAmount: connectStateroomFirst.netAmount,
              isnrp: connectStateroomFirst.isnrp,
              fareCode: connectStateroomFirst.selectedFareCode,
              amountPerNight: (connectStateroomFirst.netAmount / connectStateroomFirst.guestNumber) / (this.cruiseDetail.sailDays - 1),
              perPeopleAmount: connectStateroomFirst.perPeopleAmount,
              perNightAmount: connectStateroomFirst.perNightAmount,
            },
          ],
        };
      if (connectStaterooms.length > 1) {
        const stateroom2 = connectStaterooms[1];
        stateroom.price.push({
          originalAmount: stateroom2.originalAmount,
          portCharges: stateroom2.portCharges,
          netAmount: stateroom2.netAmount,
          isnrp: stateroom2.isnrp,
          fareCode: stateroom2.selectedFareCode,
          amountPerNight: (stateroom2.netAmount/stateroom2.guestNumber) /
              (this.cruiseDetail.sailDays - 1),
          perPeopleAmount: stateroom2.perPeopleAmount,
          perNightAmount: stateroom2.perNightAmount,
        });
      }
      return stateroom;
    },
    getStateroomList(stateroomType) {
      let stateroomItems = [];
      if (!this.stateroomCategories || this.stateroomCategories.length == 0) {
        return [];
      }
      const staterooms = this.stateroomCategories.filter(
          (r) => r.stateroomType == stateroomType
      );
      if (
          staterooms.length == 0 ||
          !staterooms[0].stateroomCategoriesItems ||
          staterooms[0].stateroomCategoriesItems.length == 0
      ) {
        return [];
      }
      staterooms[0].stateroomCategoriesItems.forEach((stateroom) => {
        let stateroomItem = stateroomItems.filter(
            (r) => r.stateroomCategoryCode == stateroom.stateroomCategoryCode
        );
        if (!stateroomItem || stateroomItem.length == 0) {
          const newStateroom = {
            ...stateroom,
            price: [
              {
                originalAmount: stateroom.originalAmount,
                portCharges: stateroom.portCharges,
                netAmount: stateroom.netAmount,
                isnrp: stateroom.isnrp,
                fareCode: stateroom.selectedFareCode,
                amountPerNight: (stateroom.netAmount / this.currentGuestNumber) / (this.cruiseDetail.sailDays - 1),
                perPeopleAmount: stateroom.perPeopleAmount,
                perNightAmount: stateroom.perNightAmount,
              }
          ],
          }
          stateroomItems.push(newStateroom);
        } else {
          stateroomItem[0].price.push({
            originalAmount: stateroom.originalAmount,
            portCharges: stateroom.portCharges,
            netAmount: stateroom.netAmount,
            isnrp: stateroom.isnrp,
            fareCode: stateroom.selectedFareCode,
            amountPerNight: (stateroom.netAmount/this.currentGuestNumber) /
              (this.cruiseDetail.sailDays - 1),
            perPeopleAmount: stateroom.perPeopleAmount,
            perNightAmount: stateroom.perNightAmount,
          });
        }
      });
      return stateroomItems;
    },
    getStateroomLowestPrice(stateroomType) {
      if (!this.stateroomCategories || this.stateroomCategories.length == 0) {
        return 0;
      }
      if (this.isConnectRoomMode) {
        // todo connect room
        let staterooms = this.stateroomCategories.filter(
            (r) => r.stateroomType == stateroomType && r.lowestPrice > 0
        );
        if (!staterooms || staterooms.length == 0) {
          return 0;
        }
        staterooms = _.orderBy(staterooms, "lowestPrice");
        return staterooms[0].lowestPrice;
      } else {
        const stateroom = this.stateroomCategories.find(
            (r) => r.stateroomType == stateroomType
        );
        if (
            !stateroom ||
            !stateroom.stateroomCategoriesItems ||
            stateroom.stateroomCategoriesItems.length == 0
        ) {
          return 0;
        }
        const staterooms = _.orderBy(
            stateroom.stateroomCategoriesItems,
            "netAmount"
        );
        return staterooms[0].netAmount / this.currentGuestNumber;
      }
    },
    onStateroomTypeChanged(stateroomType) {
      if(this.isLoading)return
      if(this.currentConnectGuestCount){
        if(this.getConnectStateroom(stateroomType).length===0){
          if(this.isConnectRoomMode) return;
          this.getOutOfStockInfo(stateroomType)
        }
      }else{
        if(this.stateroomCategories && this.stateroomCategories.length>0){
          this.stateroomCategories.forEach(item=>{
            if(item.stateroomType==stateroomType){
              if(item.stateroomCategoriesItems && item.stateroomCategoriesItems.length===0){
                if(this.isConnectRoomMode) return;
                this.getOutOfStockInfo(stateroomType)
              }
            }
          })
        }else{
          if(this.isConnectRoomMode) return;
          this.getOutOfStockInfo(stateroomType)
        }
      }
      this.currentStateroomType = stateroomType;
      this.suiteTagSelected = -1;
      gioTracking('track', 'evt_RoomClass', {
        'RoomClass': stateroomType,
        'shipCode': this.shipCode,
        'sailDate': this.sailDate
      });

      // 收起折叠
      this.clickItem = false;
      this.clickItemCon = false;
    },
    getStateroomListStyle(stateroomType) {
      return this.currentStateroomType == stateroomType
          ? { display: "block" }
          : {};
    },

    async onShoppingCartAdd(stateroomData) {
      console.log('onShoppingCartAdd')
      // 关闭选房弹框
      this.tenSecondDoFn = 'finish'

      if (!this.userToken || this.userToken.length == 0) {
        let self = this;
        this.$confirm.show("您尚未登录， 请登录之后， 再添加舱房", {
          confirmCallBack: () => {
            self.showLoginPopup(() => {
              self.onShoppingCartAdd(stateroomData);
            });
          },
        });
        return "";
      }
      let requestData = {
        viewModel: stateroomData,
      };
      this.$loading.show();
      const { success, errMsg } = await api.booking.addShoppingCart(
          requestData
      );
      this.$loading.hide();
      if (!success) {
        return errMsg;
      }
      this.getShoppingCart();
      return "";
    },
    async onShoppingCartDelete(stateroomData) {
      if (!this.userToken || this.userToken.length == 0) {
        let self = this;
        this.$confirm.show("您尚未登录， 请登录之后， 再添加舱房", {
          confirmCallBack() {
            self.showLoginPopup(() => {
              self.onShoppingCartDelete(stateroomData);
            });
          },
        });
        return;
      }
      let requestData = {
        viewModel: stateroomData,
      };
      this.$loading.show();
      const { success, errMsg } = await api.booking.deleteShoppingCart(
          requestData
      );
      if (!success) {
        this.$alert.show(errMsg);
      }
      this.$loading.hide();
      this.getShoppingCart();
    },
    async getShoppingCart() {
      const userToken = this.$store.state.user.userToken;
      if (userToken && userToken.length > 0) {
        return this.$store.dispatch("GET_SHOPPING_CART", this.userToken);
        // const { data } = await api.booking.getShoppingCart({
        //     type: 0,
        //     userName: userToken
        // })
        // if (data) {
        //     if (!data.bookings) {
        //         data.bookings = []
        //     }
        //     this.shoppingCarts = data.bookings.filter(r=>r.shipCode == this.shipCode && r.sailDate == this.sailDate)
        //     this.$store.dispatch('GET_SHOPPING_CART_COUNT')
        // }
      }
    },
    // 连通房和普通房间加购物车类似，只是需要连续加两间，并且两者的connect id必须相同
    async onConnectShoppingCartAdd(staterooms) {
      // 关闭选房弹框
      this.tenSecondDoFn = 'finish'
      if (
          staterooms.length < 2 ||
          staterooms[0].connectId != staterooms[1].connectId
      ) {
        return;
      }
      if (!this.userToken || this.userToken.length == 0) {
        let self = this;
        this.$confirm.show("您尚未登录， 请登录之后， 再添加舱房", {
          confirmCallBack: () => {
            self.showLoginPopup(() => {
              self.onConnectShoppingCartAdd(staterooms);
            });
          },
        });
        return "";
      }
      let requestData = {
        viewModel: staterooms[0],
      };
      this.$loading.show();
      const result1 = await api.booking.addShoppingCart(requestData);
      if (!result1.success) {
        // this.$alert.show(result1.errMsg)
        this.$loading.hide();
        return result1.errMsg;
      }

      let requestData2 = {
        viewModel: staterooms[1],
      };
      const reuslt2 = await api.booking.addShoppingCart(requestData2);
      this.$loading.hide();
      if (!reuslt2.success) {
        return reuslt2.errMsg;
      }

      this.getShoppingCart();
      return "";
    },
    showStateroomDetailPopup(stateroomData) {
      this.selectStateroom = stateroomData;
      console.log(stateroomData,'stateroomDatastateroomData')
      // if(stateroomData.stateroomTag){
      //   this.isShowStateroomDetailSuitePopup = true;
      // } else {
      //   this.isShowStateroomDetailPopup = true;
      // }
      // 普通房和套房使用 套房房间 详情的样式  巧虎和星空 用之前的样式
      if(stateroomData.isStarrySky == true || stateroomData.isQiaohu == true || stateroomData.isPcpGiftTheme == true || stateroomData.isCustomTheme
          == true){
        this.isShowStateroomDetailPopup = true;
      } else {
        this.isShowStateroomDetailSuitePopup = true;
      }
    },
    closeStateroomDetailPopup() {
      this.selectStateroom = {
        stateroomImages: [],
        stateroomName: "",
        stateroomCategory: "",
        stateroomPriceType: "",
        stateroomPrice: 0,
        stateroomCapacity: "",
        stateroomArea: "",
        stateroomBalcony: "",
        stateroomFloor: "",
        isQiaohu: false,
        isStarrySky: false,
        stateroomDescription: "",
        stateroomNrpTitle: "",
        stateroomNrpText: "",
        suiteMobileImageUrl: "",
        deviceFeatureTags: [],
        deviceGroupTags: []
      };
      this.isShowStateroomDetailPopup = false;
    },
    closeStateroomDetailSuitePopup() {
      this.selectStateroom = {
        stateroomImages: [],
        stateroomName: "",
        stateroomCategory: "",
        stateroomPriceType: "",
        stateroomPrice: 0,
        stateroomCapacity: "",
        stateroomArea: "",
        stateroomBalcony: "",
        stateroomFloor: "",
        isQiaohu: false,
        isStarrySky: false,
        stateroomDescription: "",
        stateroomNrpTitle: "",
        stateroomNrpText: "",
        suiteMobileImageUrl: "",
        deviceFeatureTags: [],
        deviceGroupTags: []
      };
      this.isShowStateroomDetailSuitePopup = false;
    },
    onConnectGuestSelected(connectGuestCount) {
      if (this.currentConnectGuestCount != connectGuestCount) {
        this.currentConnectGuestCount = connectGuestCount;
        if (this.currentConnectGuestCount.length > 0) {
          this.currentGuestNumber = 0;
          this.isShowConnect = false;
          this.getStateroomCategory();
          gioTracking('track', 'evt_GuestCount', {
            'GuestNumber': `C${connectGuestCount.replace(',', '')}`,
            'shipCode': this.shipCode,
            'sailDate': this.sailDate
          })
        }
      }
    },
    onConnectClose() {
      this.isShowConnect = false;
    },
    showStateroomSuitePopup(suiteImage) {
      console.log('suiteImage',suiteImage)
      if (suiteImage) {
        this.suiteImage = suiteImage;
        this.isShowSuitePopup = true;
      }
    },
    closeStateroomSuitePopup() {
      this.isShowSuitePopup = false;
    },

    closeHelperRomePopover() {
      this.isShowHelperopup = false;
    },

    showQiaohuPopup() {
      this.isShowQiaohuPopup = true;
    },
    closeQiaohuPopup() {
      this.isShowQiaohuPopup = false;
    },
    showStarrySkyPopup() {
      this.isShowStarrySkyPopup = true;
    },
    closeStarrySkyPopup() {
      this.isShowStarrySkyPopup = false;
    },
    showCustomThemePopup(val) {
      this.customThemeInfo = val;
      this.isShowCustomThemePopup = true;
    },
    closeCustomThemePopup() {
      this.isShowCustomThemePopup = false;
    },
    showConnectRoomPopup() {
      this.isShowConnectRoomPopup = true;
    },
    closeConnectRoomPopup() {
      this.isShowConnectRoomPopup = false;
    },
    showCancelPolicyPopup() {
      this.isShowCancelPolicyPopup = true;
    },
    closeCancelPolicyPopup() {
      this.isShowCancelPolicyPopup = false;
    },
    showCruisePriceInfo() {
      this.isShowCruisePriceInfoPopup = true;
    },
    closeCruisePriceInfo() {
      this.isShowCruisePriceInfoPopup = false;
    },
    pageScrollHandler(scrollY) {
      this.startTimer();
      if (this.$refs.stateroomTotalBox && this.$refs.part3) {
        if (
            this.$refs.stateroomTotalBox.offsetTop +
            this.$refs.part3.offsetTop -
            scrollY >
            window.innerHeight &&
            scrollY > 150
        ) {
          this.isTotalBoxFixed = true;
        } else {
          this.isTotalBoxFixed = false;
        }
      }
    },
    showShoppingCart() {
      this.$store.commit("SET_LEFT_MENU", 1);
    },
    suiteTagsSwitch(val) {
      this.suiteTagSelected = val.value;
    },
    closeOutOfStockPopup(){
      this.isShowOutOfStockPopup = false
    },
    changeOutOfStockRoom(i,idx){
      this.outOfStockRoom[idx].isActive = !this.outOfStockRoom[idx].isActive
      this.outOfStockRoom.forEach(i=>{
        if(i.isActive){
          this.isHaveRegistered = !!i.isRecorded
        }
      })
      if(this.outOfStockRoom.every(i=>!i.isActive)){
        this.isHaveRegistered = false
      }
    },
    // 获取登记缺货信息
    async getOutOfStockInfo(stateroomType) {
      // outOfStockEnable为true才执行登记缺货方法
      if(!this.cruiseDetail.outOfStockEnable)return
      if (!this.userToken || this.userToken.length == 0) {
        let self = this;
        this.$confirm.show("您尚未登录， 请登录之后， 再进行缺货登记", {
          confirmCallBack: () => {
            self.showLoginPopup(() => {
              self.getOutOfStockInfo(stateroomType);
            });
          },
        });
        return "";
      }
      if(this.currentConnectGuestCount.length>0){
        this.guestNumberCount = this.currentConnectGuestCount
        this.cabinRoomType = 'CONNECT_ROOM'
      }else{
        this.guestNumberCount = this.currentGuestNumber
        this.cabinRoomType = 'STANDARD'
      }
      
      this.isShowOutOfStockPopup = true

      let params = {
        ShipCode: this.shipCode,
        SailDateStr: this.sailDate,
        GuestCount: this.cabinRoomType==='STANDARD'?this.guestNumberCount:'',
        StateroomClassCode: stateroomType,
        Type:this.cabinRoomType,
        ConnectRoomGuest:this.cabinRoomType==='CONNECT_ROOM'?this.guestNumberCount:'',
      }
      this.roomName = this.setRoomName(stateroomType, this.guestNumberCount)
      this.$loading.show();
      let {success, data , errMsg} = await api.cruise.getOutOfStockInfo(params)
      this.$loading.hide();
      if(success){
        data.stateroomSubClasses && data.stateroomSubClasses.forEach(item => {
          item.isActive = false
        })
        if(data.stateroomSubClasses && data.stateroomSubClasses.length ===1){
          this.hideSelectRoom = true
          if(data.stateroomSubClasses[0].isRecorded){
            this.isHaveRegistered = true
          }else{
            data.stateroomSubClasses[0].isActive = true
            this.isHaveRegistered = false
          }
        }else{
          this.hideSelectRoom = false
          this.isHaveRegistered = false
        }
        this.outOfStockRoom = data.stateroomSubClasses
        this.outOfStockCruiseList = data.cruiseSearchItems
      }else{
        this.$alert.show(errMsg)
      }
    },
    setConnectGuestCount(){
      return this.currentConnectGuestCount.replace(/,/g, '+')
    },
    // 获取舱房名称
    setRoomName(stateroomType, num) {
      const guestNumbers = ['', '单人', '双人', '三人', '四人', '五人'];
      const roomTypes = {
        INTERIOR: '内舱房',
        OUTSIDE: '海景房',
        BALCONY:'阳台房',
        DELUXE:'套房'
      };
      if(this.guestNumberCount == '2,2'){
        return '连通' + (roomTypes[stateroomType] || '') + ' (双人房+双人房)';
      }
      if(this.guestNumberCount == '2,3'){
        return '连通' + (roomTypes[stateroomType] || '') + ' (双人房+三人房)';
      }
      return (guestNumbers[num] || '') + (roomTypes[stateroomType] || '');
    },
    //   提交缺货登记
    async submitOutOfStock() {
      if (this.isShowNullRoomTips) return;
      let ids = []
      if (this.outOfStockRoom && this.outOfStockRoom.length > 0) {
        this.outOfStockRoom.forEach(item => {
          if (item.isActive) {
            ids.push(item.stateroomSubClassId)
          }
        })
      }
      if (ids.length <= 0) {
        this.isShowNullRoomTips = true
        setTimeout(() => {
          this.isShowNullRoomTips = false
        }, 1500)
        return
      }
      let params = {
        ShipCode: this.shipCode,
        SailDateStr: this.sailDate,
        GuestCount: this.cabinRoomType==='STANDARD'?this.guestNumberCount:'',
        Source: "PC",
        StateroomSubClassRecordIds: ids,
        Type:this.cabinRoomType,
        ConnectRoomGuest:this.cabinRoomType==='CONNECT_ROOM'?this.guestNumberCount:''
      }
      this.$loading.show();
      let {success,errMsg} = await api.cruise.submitOutOfStock(params)
      this.$loading.hide();
      if (success) {
        this.$alert.show('提交成功')
        // 提交成功后，如果偏好房间就一个选项，隐藏偏好选择
        if(this.outOfStockRoom.length<=1){
          this.hideSelectRoom = true
        }
        this.isHaveRegistered = true
      }else{
        this.$alert.show(errMsg)
      }
    },
    getCruiseOutOfStock() {
      try {
        const stateroomTypes = ['INTERIOR', 'OUTSIDE', 'BALCONY', 'DELUXE'];
        const allSoldOut = stateroomTypes.every(type => {
          const isSoldOut = this.getStateroomLowestPrice(type) ==0;
          return isSoldOut === true; // 确保返回值是布尔类型
        });
        return allSoldOut;
      } catch (error) {
        console.error('Error in getCruiseOutOfStock:', error);
        return false; // 在发生异常时返回 false，确保方法总是有明确的返回值
      }
    },
    getStateroomKey(stateroom, index) {
      const {currentGuestNumber, stateroomType, stateroomCategoryCode} = stateroom
      return `stateroom_${currentGuestNumber}_${stateroomType}_${stateroomCategoryCode}_${index}`
    },
    getConnectStateroomKey(stateroom, index) {
      const { connectStateroomFirsts, connectStateroomSeconds } = stateroom || {}
       if(!connectStateroomFirsts || !connectStateroomSeconds){
        return `connect_${stateroom?.connectId || 'unknown'}_${index}`
       }
      let currentGuestNumber = `${connectStateroomFirsts?.currentGuestNumber}-${connectStateroomSeconds?.currentGuestNumber}`
      let stateroomCategoryCode = `${connectStateroomFirsts?.stateroomCategoryCode ??'unknown'}-${connectStateroomSeconds?.stateroomCategoryCode ??'unknown'}`
      return `connect_${stateroom.connectId}_${currentGuestNumber}_${stateroom.stateroomType}_${stateroomCategoryCode}_${index}`
    }
  },
  computed: {
    // userInfo() {
    //   return this.$store.state.user.userInfo;
    // },
    pppKey() {
      return this.$store.state.user.pppKey;
    },
    isPPP() {
      return (
          this.pppKey &&
          this.pppKey.length > 0 &&
          this.userInfo &&
          this.userInfo.isPartner
      );
    },
    shipCode() {
      return this.cruiseDetail.shipCode;
    },
    sailDate() {
      return this.cruiseDetail.sailDate;
    },
    stateroomTypes() {
      return ["INTERIOR", "OUTSIDE", "BALCONY", "DELUXE"];
    },
    needShowConnectRoom() {
      return true;
    },
    qiaohuGroup() {
      if (
          this.cruiseDetail.cruiseGroups &&
          this.cruiseDetail.cruiseGroups.length > 0
      ) {
        const cruiseGroups = this.cruiseDetail.cruiseGroups.filter(
            (group) => group.groupType == "QIAOHU" && group.isPublished
        );
        if (cruiseGroups && cruiseGroups.length > 0) {
          return cruiseGroups[0];
        }
      }
      return {};
    },
    qiaohu3Stock() {
      if (!this.cruiseDetail || !this.cruiseDetail.qH_Gruest3_Stock) return 0;
      return this.cruiseDetail.qH_Gruest3_Stock;
    },
    qiaohu4Stock() {
      if (!this.cruiseDetail || !this.cruiseDetail.qH_Gruest4_Stock) return 0;
      return this.cruiseDetail.qH_Gruest4_Stock;
    },
    hasQiaohu() {
      if (!this.stateroomCategories || this.stateroomCategories.length == 0)
        return false;
      const stateroom = this.stateroomCategories.find(
          (r) => r.stateroomType == "BALCONY"
      );
      if (!stateroom || !stateroom.qiaoHu_Stock) return false;
      return stateroom.qiaoHu_Stock > 0;
    },
    isConnectRoomMode() {
      return this.currentConnectGuestCount.length > 0;
    },
    agencyId() {
      return this.isPPP ? bookingHelper.pppAgencyId : bookingHelper.agencyId;
    },
    isShowNrp() {
      if (!this.cruiseDetail.price) {
        return false;
      }
      const nrpPrice = this.cruiseDetail.price.nrpAmout;
      const rpPrice = this.cruiseDetail.price.netAmout;
      if (nrpPrice > 0 && nrpPrice <= rpPrice) {
        return true;
      }
      return false;
    },
    totalAmount() {
      let amount = 0;
      this.shoppingCarts.forEach((shoppingCart) => {
        amount += shoppingCart.amount;
      });
      return amount;
    },
    totalDeposit() {
      let deposit = 0;
      this.shoppingCarts.forEach((shoppingCart) => {
        deposit += shoppingCart.guestNumber;
      });
      return this.depositPrice * deposit;
    },
    userToken() {
      return this.$store.state.user.userToken;
    },
    allStaterooms() {
      let staterooms = [];
      this.stateroomTypes.forEach((type) => {
        const items = this.getStateroomList(type);
        staterooms = staterooms.concat(items);
      });
      
      return staterooms;
    },
    isShowFolded() {
      let arr = this.allStaterooms.filter(item => {
        if(item.stateroomType === this.currentStateroomType){
          return true
        }
      })
      console.log(arr,'arrarr');
      let index = arr.findIndex(item => item.isFolded == true)
      return index > 0
    },
    isShowItem(){
      return (item)=>{
        if(item.isFolded == true && this.clickItem == false){
          return false
        }else{
          return true
        }
      }
    },
    isShowFoldedCon() {
      let arr = this.getConnectStateroom(this.currentStateroomType).filter(item => {
        if(item.stateroomType === this.currentStateroomType){
          return true
        }
      })
      console.log(arr,'arrarr');
      let index = arr.findIndex(item => item.isFolded == true)
      return index > 0
    },
    isShowItemCon(){
      return (item)=>{
        if(item.isFolded == true && this.clickItemCon == false){
          return false
        }else{
          return true
        }
      }
    },
    storeShoppingCarts() {
      return this.$store.state.booking.shoppingCarts;
    },
    //包含套房
    isDeluxeStateroom() {
      let deluxeNum = 0;
      if(this.shoppingCarts) {
        this.shoppingCarts.forEach((row)=> {
          if(row.stateroomType === "DELUXE") {
            deluxeNum+=1;
          }
        })
      }
      return deluxeNum > 0;
    },
    specialBookingInfo() {
      if (
          !this.cruiseDetail ||
          !this.cruiseDetail.specialBookingViews ||
          this.cruiseDetail.specialBookingViews.length <= 0
      ) {
        return {};
      }
      return this.cruiseDetail.specialBookingViews[0];
    },
  },
  watch: {
    cruiseDetail() {
      this.initData();
    },
    storeShoppingCarts(newValue) {
      this.shoppingCarts = newValue.filter(
          (r) => r.shipCode == this.shipCode && r.sailDate == this.sailDate
      );
    },
  },
};
</script>

<style lang="less" scoped>

.title_box{
  display: flex;
  align-items: center;
  width: 100%;
}
.helper-box{
  width: 127px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('https://resource.rcclchina.com.cn/wechatMiniProgram/routesDetail/housingSelection/cardBox.png');
  background-size: 100% 100%;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
  div{
    margin: 0 2px;
  }
}
.helper-box-home{
  width: 20px;
  height: 18px;
}
.helper-box-arrow{
  width: 10px;
  height: 10px;
}

.part3 {
  color: #5a5a5a;
  .part3_hd {
    margin-bottom: 5px;
    .title_left {
      font-size: 22px;
      color: #282b2c;
      font-weight: 400;
    }
    
    .title_tips {
      color: #0073bb;
      margin-left: 10px;
      position: relative;
      top: 12px;
      cursor: pointer;
      font-size: 12px;
      font-weight: 400;
      img {
        position: relative;
        top: -1px;
        margin-left: 5px;
      }
    }
    .nrpTips {
      text-align: center;
      color: white;
      border-radius: 11px;
      position: relative;
      margin-left: 25px;
    }
  }
  .part3_bd {
    .tab_hd {
      .row.new-gutter {
        margin-left: -5px;
        margin-right: -5px;
        > [class*="col-"] {
          padding-right: 5px;
          padding-left: 5px;
        }
      }
      .row.new-gutter.show-connect-room > [class*="col-"] {
        width: 233px;
        padding-right: 0px;
      }
      .list_box {
        width: 100%;
        height: 100px;
        overflow: hidden;
        position: relative;
        border-radius: 10px;
        .pop_bj,
        .pop_border {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          display: block;
        }
        .pop_bj {
          background: url(https://resource.rcclchina.com.cn/tui2/detail/block_06.png)
          repeat;
        }
        .pop_border {
          font-size: 20px;
          color: #fff;
          font-weight: bold;
          text-align: center;
          line-height: 100px;
          > span {
            display: block;
            line-height: 0;
            width: 125px;
            text-shadow: 0px 0px 10px rgba(175, 140, 0, 0.54);
          }
          .pop_pers {
            margin: 0 auto;
            line-height: 35px;
            margin-top: 16px;
            font-size: 25px;
            border-bottom: 2px solid #fff;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            .optOfSellOut{
              font-size: 18px;
            }
          }
          .pop_even {
            line-height: 30px;
            font-size: 16px;
            margin: 0 auto;
          }
        }
        .pop_tips{
          width: 68px;
          height: 22px;
          text-align: center;
          line-height: 22px;
          position: absolute;
          color: #fff;
          left: 50%;
          bottom: 11px;
          transform: translate(-50%);
          font-size: 14px;
          border-radius: 3px;
          display: none;
        }
        .QIAOHU_pop_border {
          position: absolute;
          top: -15px;
          left: 0;
          bottom: 0;
          right: 0;
          display: block;
          font-size: 20px;
          color: #fff;
          font-weight: bold;
          text-align: center;
          line-height: 100px;
        }

        .QIAOHU_center {
          position: absolute;
          top: 51px;
          left: 25%;
          right: 25%;
          color: #fbc500;
          font-weight: bold;
          width: 140px;
          border-top: 1px solid;
        }

        .QIAOHU_guestRoom {
          position: absolute;
          top: 15px;
          left: 0;
          right: 0;
          display: block;
          font-size: 16px;
          color: #fbc500;
          text-align: center;
          line-height: 100px;
        }
      }
      .active .c_room_outOfStock.pop_tips{
        display: block;
      }
      .active .pop_tips{
        display: none;
      }
      .active .c_room_outOfStock .optOfSellOut {
        display: block;
      }
      .active .optOfSellOut{
        display: none;
      }
      .roomInfo:hover .pop_border {
        color: #febc10;
      }

      .roomInfo.active:hover .pop_border {
        color: #fff;
      }

      .list_box.active {
        .pop_bj {
          background: url(https://resource.rcclchina.com.cn/tui2/detail/yellow2.png)
          repeat;
        }
        .QIAOHU_guestRoom,
        .QIAOHU_center {
          color: white;
        }
      }
    }
    .tab_hd_child {
      .row.no-gutter {
        margin-left: 0;
        margin-right: 0;
        > [class*="col-"] {
          padding-right: 0;
          padding-left: 0;
        }
      }
      li {
        border-top: 1px solid #d2dadc;
        border-bottom: 1px solid #d2dadc;
        border-right: 1px solid #d2dadc;
        padding: 8px 0px;
        min-height: 60px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .list_box {
          text-align: center;
          cursor: pointer;
          font-weight: 400;
          .room_type {
            font-size: 15px;
          }
          .roo_price {
            font-size: 15px;
            line-height: 22px;
            margin-top: 3px;
          }
        }
      }
      li:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        border-left: 1px solid #d2dadc;
      }
      li.cur {
        border-bottom: 4px solid #fbc500;
      }
      li::after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        width: 97px;
        height: 60px;
      }
      li:hover:not(.cur) {
        color: #febc10;
      }
      .first_label {
        position: relative;
      }
      .first_label::after {
        background: url(https://resource.rcclchina.com.cn/cruiseDetail/part3_lable2.png)
        no-repeat;
      }
      .over_label::after {
        background: url(https://resource.rcclchina.com.cn/tui2/detail/part3_table_hd_child_label.png)
        no-repeat;
        background-position: -97px 0px;
      }
      .suite_label::after {
        background: url(https://resource.rcclchina.com.cn/cruiseDetail/suite_lable.png)
        no-repeat;
      }
      .outOfStockTips{
        width: 68px;
        height: 20px;
        text-align: center;
        line-height: 20px;
        border-radius: 3px;
        color: #a6aeb1;
        border: 1px solid #eee;
        margin: 5px auto 0;
        font-size: 12px;
      }
    }
  }

  .total_box {
    overflow: hidden;
    border: 1px solid #fbc500;
    .f-fl {
      float: left;
      display: inline-block;
      padding-left: 10px;
      line-height: 70px;
      height: 70px;
      & em {
        font-style: normal;
        font-weight: bold;
        padding: 0 3px;
      }
    }
    .f-fr {
      display: inline-block;
      text-align: right;
      height: 70px;
      span {
        margin-left: 30px;
        vertical-align: middle;
      }
      .room_num {
        color: #3b87c5;
        position: relative;
        font-weight: 400;
        cursor: pointer;
        margin-right: 38px;
      }
      .room_num:after {
        content: "";
        display: block;
        width: 1px;
        height: 14px;
        background: #3b87c5;
        position: absolute;
        top: 3px;
        right: -19px;
      }
      .price_deposit_info {
        display: inline-block;
        & .total_price {
          height: 40px;
          margin-top: 14px;
          &.is_deposit {
            margin-top: 0;
          }
          em {
            height: 20px;
            display: inline-block;
            font-style: normal;
            margin-top: 10px;
          }
          .unit {
            color: #ff3022;
            font-weight: bold;
            margin-left: 10px;
          }
          .price_num {
            margin-top: 0;
            display: inline-block;
            color: #ff3022;
            font-size: 30px;
            font-weight: bold;
          }
          .price_details {
            display: inline-block;
            position: relative;
            font-weight: bold;
            padding-right: 15px;
            color: #276fbe;
            &:after {
              content: "";
              display: block;
              width: 0;
              height: 0;
              border: 5px solid transparent;
              border-top-color: #276fbe;
              position: absolute;
              top: 7px;
              right: 0;
            }
          }
        }
        .total_deposit {
          height: 25px;
          margin-top: 2px;
          & > img {
            display: inline-block;
            height: 18px;
            margin-top: 2px;
          }
          & > span {
            display: inline-block;
            line-height: 20px;
            margin-left: 4px;
          }
        }
      }
      .next_btn {
        float: right;
        font-size: 18px;
        color: #282b2c;
        background: #fbc500;
        width: 221px;
        text-align: center;
        margin-left: 30px;
        vertical-align: middle;
        line-height: 72px;
        height: 72px;
      }
    }
  }

  .floating-button {
    position: fixed;
    bottom: 0px;
    width: 1160px;
    background-color: #f0f0f0f0;
    z-index: 999;
  }

  .col-connect-room {
    position: relative;
    z-index: 999;
    .mask-box {
      width: 250px;
      min-height: 282px;
      position: absolute;
      left: -7px;
      top: -10px;
      background: #fff;
      border-radius: 8px;
      padding: 10px;
      box-sizing: border-box;
      box-shadow: 0px 0px 7px 7px rgba(46, 65, 80, 0.1);
      .mask-pic {
        width: 228px;
        margin-left: 2px;
        height: 100px;
        border-radius: 8px;
        overflow: hidden;
        position: relative;
        > img {
          width: 100%;
          height: 100%;
        }
        .choose-title {
          width: 100%;
          position: absolute;
          left: 0;
          bottom: 0;
          background: #fbc501;
          text-align: center;
          line-height: 22px;
          font-size: 14px;
          color: #282b2c;
          font-weight: 500;
        }
      }
      .roomtype_even,
      .roomtype_odd {
        width: 230px;
        padding: 10px 0;
        //line-height: 40px;
        border: 1px solid #d3dadd;
        text-align: center;
        font-size: 16px;
        color: #747d80;
        border-radius: 6px;
        margin-top: 4px;
        font-weight: 400;
        cursor: pointer;
        .optOfSellOut{
          display: none;
          //height: 30px;
          font-size: 14px;
          line-height: 24px;
          color: #7c8789;
        }
        .active .c_room_outOfStock .optOfSellOut {
          display: block !important;
        }
        .active .optOfSellOut{
          display: none;
        }
      }
      .type_img {
        margin: 13px auto;
        cursor: pointer;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }
      .pop_new {
        top: 16px;
        right: 16px;
      }
    }
  }

  .pop_new {
    width: 44px;
    height: 17px;
    position: absolute;
    top: 6px;
    right: 6px;
  }

  .roomInfo,
  #next_btn {
    cursor: pointer;
  }
}
.outOfStockPopup{
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  z-index: 999;
  .outOfStockCon{
    width: 836px;
    max-height:85%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    background: #fff;
    overflow: auto;
    .outOfStockHeader{
      padding: 30px 0;
      text-align: center;
      font-size: 17px;
      font-weight: bold;
      color: #333333;
      margin: 0 15px;
      border-bottom: 1px solid #d9d9d9;
      img{
        display: block;
        position: absolute;
        width: 20px;
        height: 20px;
        padding: 3px;
        right: 22px;
        top: 15px;
        cursor: pointer;
      }
    }
    .outOfStock-title{
      font-size: 17px;
      color: #333;
      position: relative;
      margin-left: 30px;
      padding-left: 20px;
      margin-top: 26px;
      font-weight: bold;
    }
    .outOfStock-title:after{
      content: "";
      position: absolute;
      width: 4px;
      height: 15px;
      top: 50%;
      transform: translate(0,-40%);
      left: 0;
      background: #fcc300;
    }
    .recommendedRoute-list{
      //height: 360px;
      padding-left: 30px;
    }
    .outOfStock-roomName{
      font-size: 16px;
      color: #333333;
      padding-left: 50px;
      margin-top: 20px;
      display: flex;
      align-items: center;
      .roomName{
        position: relative;
        padding: 0 5px;
      }
      .roomName:after{
        content: "";
        position: absolute;
        width: 100%;
        height: 8px;
        background-color: #FCC300;
        left: 0;
        bottom: 0;
        z-index: -1;
      }
    }
    .outOfStock-selectRoom{
      display: flex;
      align-items: center;
    }
    .selectRoom-main{
      margin-top: 20px;
      color: #333333;
      font-size: 16px;
      display: flex;
      align-items: center;
      gap: 20px;
      .selectRoom-item{
        display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;
      }
    }
    .confirmBtn{
      width: 370px;
      height:  50px;
      line-height: 50px;
      background: linear-gradient( 90deg, #fcbf00 0%, #ffdb17 100%);
      border-radius: 4px;
      font-weight: 600;
      font-size: 18px;
      text-align: center;
      color: #333333;
      margin: 40px auto 9px;
      cursor: pointer;
    }
    .haveRegistered{
      width: 370px;
      height:  50px;
      line-height: 50px;
      background: #E9E9E9;
      border-radius: 4px;
      font-weight: 600;
      font-size: 18px;
      text-align: center;
      color: #939393;
      margin: 40px auto 9px;
      cursor: pointer;
    }
    .outOfStock-tips{
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      text-align: center;
      margin-bottom: 20px;
    }
    .tips-text{
      position: absolute;
      bottom: 138px;
      left: 50%;
      transform: translate(-50%,-50%);
      text-align: center;
      font-size: 18px;
      color: #fff;
      width: 318px;
      height: 64px;
      border-radius: 6px;
      line-height: 64px;
      background: rgba(0,0,0,0.6);
    }
  }
}
.folded-box{
  background-color: #f9c500;
  width: 100%;
  height: 33px;
  margin-bottom: 20px;
  color: #4f472a;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.folded-box-text{
  margin-right: 8px;
}
.folded-box-text-img{
  transform: rotate(180deg);
}
</style>
